export enum ADDITIONAL_ROLE_ID {
    BOOTH_CAPTAIN,
    SCRUTINEER,
}
